// eslint-disable-next-line no-control-regex -- Safari cannot parse these characters in rendered Markdown.
const UNSUPPORTED_CONTROL_CHARACTERS = /[\x00-\x08\x0B\x0C\x0E-\x1F]/g;

export function sanitizeMarkdown(markdown: string): string {
  return markdown.replace(UNSUPPORTED_CONTROL_CHARACTERS, '');
}
